import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalBody', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'flex',
    margin: '0',
    overflowY: 'auto',
    flexGrow: '1',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalBody.tsx